export enum ChartGranularity {
  "Monthly" = "Monthly",
  "Yearly" = "Yearly",
}
